import { render } from "./MenuRegister.vue?vue&type=template&id=426d4818&scoped=true"
import script from "./MenuRegister.vue?vue&type=script&lang=js"
export * from "./MenuRegister.vue?vue&type=script&lang=js"

import "./MenuRegister.vue?vue&type=style&index=0&id=426d4818&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426d4818"]])

export default __exports__